<template>
    <span>
        <v-navigation-drawer 
            class="light-blue darken-4"
            app v-model="drawer" 
            disable-resize-watcher
            right
            dark>
            <v-list>
                <template v-for="(item, index) in items">
                    <v-list-item :key="index">
                        <v-btn block text v-scroll-to=item.to_link :retain-focus-on-click="false">
                            <v-list-item-content>
                                {{item.title}}
                            </v-list-item-content>
                        </v-btn>
                    </v-list-item>
                    <v-divider :key="`divider-${index}`">
                    </v-divider>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar id="lander" color="light-blue darken-4" app flat dark>
            <v-toolbar-title>Ryan Russell</v-toolbar-title>
            
            <v-spacer></v-spacer>
            <v-app-bar-nav-icon
                class="hidden-md-and-up"
                @click="drawer = !drawer">
            </v-app-bar-nav-icon>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn text v-scroll-to="'#lander'" :retain-focus-on-click="false">Home</v-btn>
                <v-btn text v-scroll-to="'#teaching'" :retain-focus-on-click="false">Teaching</v-btn>
                <v-btn text v-scroll-to="'#research'" :retain-focus-on-click="false">Research</v-btn>
                <v-btn text v-scroll-to="'#resume'" :retain-focus-on-click="false">Resume</v-btn>
                <v-btn text v-scroll-to="'#contact'" :retain-focus-on-click="false">Contact</v-btn>
            </v-toolbar-items>
        </v-toolbar>
    </span>
</template>

<script>
export default {
    name: 'AppNavigation',
    data() {
        return {
            appTitle: "Ryan Russell",
            drawer: false,
            items: [
                { title: 'Home', to_link: "#lander"},
                { title: 'Teaching', to_link: "#teaching"},
                { title: 'Research', to_link: "#research"},
                { title: 'Resume', to_link: "#resume"},
                { title: 'Contact', to_link: "#contact"}
            ]
        };
    }
};
</script>

<style scoped>
.v-toolbar {
    padding-left: 1.5%;
}
</style>
